import { render, staticRenderFns } from "./swiper.vue?vue&type=template&id=58b45e42"
import script from "./swiper.vue?vue&type=script&lang=js"
export * from "./swiper.vue?vue&type=script&lang=js"
import style0 from "./swiper.vue?vue&type=style&index=0&id=58b45e42&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports